// extracted by mini-css-extract-plugin
module.exports = {"avatar":"e_Yfb","fallback":"e_Zfb","s40":"e__fb","s32":"e_0fb"};